import React from "react";
import { useOfflineStatus } from "../lib/useOffline";
import { CloudOff, UploadCloud, RefreshCw } from "lucide-react";

/** Thin status strip that appears below the top tabs when the user is
 *  offline OR has pending drafts waiting to sync. Hidden when all-clear. */
export default function OfflineBanner() {
  const { online, pending, syncing, syncNow } = useOfflineStatus();

  if (online && pending === 0) return null;

  const bg = !online ? "bg-amber-500" : "bg-[#1F2A47]";
  const Icon = !online ? CloudOff : UploadCloud;

  return (
    <div
      data-testid="offline-banner"
      className={`${bg} text-white text-xs font-semibold px-4 py-2 flex items-center justify-between gap-3 no-print`}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Icon className="w-4 h-4 flex-shrink-0" strokeWidth={2.2} />
        <span className="truncate">
          {!online
            ? pending > 0
              ? `Offline · ${pending} draft${pending === 1 ? "" : "s"} will sync when you reconnect`
              : "You're offline — Quick Log entries will save locally"
            : `${pending} draft${pending === 1 ? "" : "s"} waiting to sync`}
        </span>
      </div>
      {online && pending > 0 && (
        <button
          data-testid="offline-sync-now-btn"
          data-raw="true"
          onClick={syncNow}
          disabled={syncing}
          className="flex items-center gap-1.5 bg-white/15 hover:bg-white/25 px-3 py-1 rounded-full text-[11px] uppercase tracking-wider disabled:opacity-50 flex-shrink-0"
        >
          <RefreshCw className={`w-3 h-3 ${syncing ? "animate-spin" : ""}`} />
          {syncing ? "Syncing…" : "Sync now"}
        </button>
      )}
    </div>
  );
}
